<div class="promo-social-container">
  <div class="promo-video-wrapper">
    <video
      #promoVideo
      class="promo-video"
      autoplay
      controls
      muted
      loop
      playsinline
      poster="img/rijeka/video-poster.png"
      preload="metadata"
      loading="lazy"
    >
      <source src="video/promo-video.mp4" type="video/mp4" />

      <track kind="descriptions" src="" srclang="hr" label="Desc" default/>

      <!-- Fallback content if <video> isn’t supported -->
      Your browser does not support HTML5 video. Please <a href="video/promo-video.mp4">download the video</a> to watch.
    </video>

    <div class="promo-block">
      <p class="promo-title">{{'PROMO.TITLE' | translate}}</p>

      <div class="feature-block">
        <p class="feature-title">{{'PROMO.OFFER' | translate}}</p>
        <ul class="feature-list">
          <li>{{'PROMO.OFFER_DESC_1' | translate}}</li>
        </ul>
        <p class="mt-2">{{'PROMO.DESC' | translate}}</p>
      </div>

      <!--<p class="promo-notice"><b>{{'PROMO.NOTICE' | translate}} </b><i>{{'PROMO.NOTICE_DESC' | translate}}</i></p>-->

      <ng-container *ngIf="becomingMemberDisabled && !userHasMembership; else normalView">
        <div class="disabled-becoming-member">
          <button type="button" class="btn btn-secondary" [disabled]="becomingMemberDisabled" (click)="openMembershipModal()">{{'FOOTER.BECOME_MEMBER' | translate}}</button>
          <span class="tooltip-become-member">{{ "NAVIGATION.TOOLTIP_MEMBERSHIP" | translate }}</span>
        </div>
      </ng-container>
      <ng-template #normalView>
        <button type="button" class="btn btn-secondary" (click)="openMembershipModal()" *ngIf="!userHasMembership">{{'FOOTER.BECOME_MEMBER' | translate}}</button>
      </ng-template>
    </div>
  </div>

  <app-socials></app-socials>
</div>
